<template>
  <div class="now-playing-info py-sm-2 py-lg-4">
    <div class="now-playing-info-inner">
      <div
        v-if="
          track &&
          track.noAutoplay != true &&
          track.shouldNotUpdateNowplaying != true
        "
      >
        <div
          class="mt-2 mt-sm-0 order-1 order-sm-1 pr-sm-0 album-img-container"
        >
          <a
            href="#"
            class="align-self-start"
            v-if="track.album"
            @click.prevent="openAlbum(track.album)"
          >
            <img
              class="img-fluid track-info-img"
              v-bind:src="image"
              alt="Album Image"
            />
          </a>
          <img
            v-if="!track.album"
            class="align-self-start img-fluid track-info-img"
            v-bind:src="image"
            alt="Album Image"
          />
          <button
            class="favourite"
            :class="{
              favourited: favourited,
              ['now-playing-album-' + this.track.album.id + '-favourite']: true,
            }"
            data-toggle="tooltip"
            data-placement="top"
            v-bind:title="
              isFavourite(track.album.id) ? 'Unfavourite' : 'Favourite'
            "
            @click.prevent="
              isFavourite(track.album.id)
                ? unfavourite(track.album.id)
                : favourite(track.album.id)
            "
          >
            <i class="material-icons">star_rate</i>
          </button>
        </div>

        <div class="order-2 order-sm-2 col-track-info">
          <div class="track-info-body">
            <div class="position-relative">
              <div class="col-title">
                <span> Title </span>
                <a
                  href="#"
                  class="copy-track-info"
                  @click.prevent="copyTrackInfo"
                  title="Copy track information"
                >
                  <i class="material-icons">content_copy</i>
                </a>
              </div>

              <div class="col-info">
                <a
                  href="#"
                  @click.prevent="openTrackResultsForId(track.id)"
                  class="now-playing-track"
                  :data-track-id="track.id"
                >
                  {{ track.track_number }}.&nbsp;{{ track.title }}
                </a>
              </div>
            </div>

            <div class="position-relative">
              <div class="col-title">
                <strong> Album </strong>
              </div>

              <div class="col-info">
                <a
                  href="#"
                  v-if="track.album"
                  @click.prevent="openAlbum(track.album)"
                  class="now-playing-album"
                  :data-album-id="track.album_id"
                >
                  <span v-if="this.track.album">
                    {{ track.album.name }}
                  </span>
                  <span v-if="!this.track.album"> No Album </span>
                </a>

                <span v-if="!track.album"> No album </span>
              </div>
            </div>

            <div class="position-relative">
              <div class="col-title">
                <strong> Library </strong>
              </div>

              <div class="col-info">
                <a
                  href="#"
                  v-if="track.album && track.album.library"
                  @click.prevent="openLibrary(track.album.library.id)"
                >
                  {{ track.album.library.name }}
                </a>

                <span v-if="!track.album || !track.album.library">
                  No library
                </span>
              </div>
            </div>

            <div class="position-relative">
              <div class="col-title">
                <strong> Composer </strong>
              </div>

              <div class="col-info">
                <a
                  href="#"
                  v-if="track.composer"
                  @click.prevent="openComposer(track.composer)"
                >
                  {{ track.composer }}
                </a>

                <span v-if="!track.composer"> Unknown </span>
              </div>
            </div>

            <div class="position-relative">
              <div class="col-title">
                <strong> Genre </strong>
              </div>

              <div class="col-info">
                <div
                  class="track-genre"
                  v-if="track.genres"
                  v-for="genre in track.genres"
                  :key="genre.id"
                >
                  <a href="#" @click.prevent="openGenre(genre)">{{
                    genre.name
                  }}</a>
                </div>

                <span v-if="!track.genres || !track.genres.length"> ---- </span>
              </div>
            </div>

            <div class="clearfix"></div>

            <div class="row">
              <div class="col-6 add-project">
                <a href="#" @click.prevent="addToProject">
                  <i class="material-icons">add</i>
                </a>
              </div>

              <div class="col-6 download-track">
                <a href="#" @click.prevent="download" title="Download Track">
                  <i class="material-icons">cloud_download</i>
                </a>
              </div>

              <span
                class="d-inline-flex d-md-none"
                @click="toggleNowPlayingInformation()"
              >
                <button type="button" class="btn btn-link close-now-playing">
                  <i class="material-icons">close</i>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import { audioService } from "../audio-service";
import ToastrType from "../toastr-types.interface";

export default Vue.component("now-playing", {
  data: function () {
    return {
      track: null,
    };
  },
  props: {
    asseturl: {
      required: true,
    },
  },
  computed: {
    image: function () {
      return this.track.album && this.track.album.image
        ? this.asseturl + this.track.album.image.replace(/^\/?/, "/")
        : "/images/player-no-album-img.png";
    },

    genres: function () {
      if (this.track.genres) {
        return this.track.genres;
      } else {
        return "No Genres";
      }
    },

    favourited: function () {
      return this.isFavourite();
    },
  },

  mounted: function () {
    // When any now playing track updates, get the data and update our now playing component with it.
    audioService.$on("stream-track", (info) => {
      this.track = info.track;

      if (info.track.shouldNotUpdateNowplaying == true) {
        $(".now-playing-info-inner > div").hide();
      } else {
        $(".now-playing-info-inner > div").show();
      }
    });

    playerService.$on("show-random-track-info", () => {
      if (this.track.shouldNotUpdateNowplaying == true) {
        this.track.shouldNotUpdateNowplaying = false;
        $(".now-playing-info-inner > div").show();
      }
    });

    // When an autoplay track is now begun playing the actual audio, display the artwork and track info.
    playerService.$on("noautoplay-track-now-playing", (track) => {
      if (this.track) {
        this.track.noAutoplay = false;
      }
    });
  },

  methods: {
    isFavourite: function (albumId) {
      return window.favAlbums.indexOf(albumId) !== -1;
    },

    copyTrackInfo: function () {
      const info = [
        `Track Filename: ${this.track.file ? this.track.file : ""}`,
        `Track Title: ${this.track.title}`,
        `Track Number: ${this.track.track_number}`,
        `Album Name: ${this.track.album ? this.track.album.name : "No album"}`,
        `Library Name: ${this.track.album && this.track.album.library ? this.track.album.library.name : "No library"}`,
        `Composers: ${this.track.composer || "Unknown"}`,
      ].join("\n");

      navigator.clipboard
        .writeText(info)
        .then(() => {
          playerService.toast("Copied to clipboard!", ToastrType.Success);
        })
        .catch(() => {
          playerService.toast(
            "Failed to copy track information",
            ToastrType.Error,
          );
        });
    },

    onTrackInfoClick: function (info) {
      playerService.$emit("set-tracksearch-input", info);
    },

    openTrackResultsForId: function (id) {
      playerService.$emit("collapse-sub-tracks");

      playerService.openTrackResultsForId(id);
    },

    addToProject: function () {
      playerService.openAddProjectTrack(this.track);
    },

    download: function () {
      playerService.download(this.track);
    },

    openAlbum: function (album) {
      window.cancelAlbumResultsAlterations = false;

      playerService.$emit("collapse-sub-tracks");
      playerService.$emit("reset-filters");
      playerService.$emit("search-query-updated", "");

      playerService.$emit("set-invisible-filters", {
        id: "album.id",
        model: "album",
        modelField: "name",
        name: "Album",
        namePlural: "Albums",
        values: [album.id],
      });

      playerService.setSearchHistory("Album", album.id, album.name);
    },

    openLibrary: function (libraryId) {
      playerService.$emit("collapse-sub-tracks");

      window.cancelAlbumResultsAlterations = false;

      let clearAlbums = false;

      playerService.openLibrary(libraryId, clearAlbums);
    },

    openComposer: function (composerName) {
      playerService.$emit("collapse-sub-tracks");

      window.cancelAlbumResultsAlterations = false;

      playerService.openComposerTracks(composerName);

      let composerData = {
        type: "Composer",
        name: composerName,
      };

      let searchHistory = [];

      // Looop through our search history, if the current search value exists, move it to the top.
      if (playerService.getLs("search")) {
        searchHistory = JSON.parse(playerService.getLs("search"));

        for (let value in searchHistory) {
          if (
            JSON.stringify(searchHistory[value]) == JSON.stringify(composerData)
          ) {
            searchHistory.splice(value, 1);
          }
        }
      } else {
        searchHistory = [];
      }

      searchHistory.unshift(composerData);

      playerService.setLs(
        "search",
        JSON.stringify(searchHistory),
        60 * 60 * 24000,
      );
    },

    openGenre: function (genre) {
      playerService.$emit("collapse-sub-tracks");

      window.cancelAlbumResultsAlterations = false;

      playerService.trackResultsFromGenre(genre.id, true);
      playerService.albumResultsFromGenre(genre.id);

      playerService.setSearchHistory("Genre", genre.id, genre.name);
    },

    toggleNowPlayingInformation: function () {
      $("body").removeClass("explore-mobile-visible search-mobile-visible");

      if ($("body").hasClass("now-playing-mobile-visible")) {
        $("body").removeClass("now-playing-mobile-visible");

        setTimeout(function () {
          playerService.$emit("collapsed-track-info");
        }, 500);
      } else {
        $("body").addClass("now-playing-mobile-visible");
      }
    },

    unfavourite: function (albumId) {
      playerService.removeFavouriteAlbum(albumId);
    },

    favourite: function (albumId) {
      playerService.addFavouriteAlbum(albumId);
    },
  },
});
</script>
